<template>
  <el-popover
    popper-class="product-popover"
    v-model="isShowAddSpecification"
    :placement="placement"
    :disabled="disabled"
    width="280"
    trigger="click"
  >
    <div>
      <div class="popover-header">
        <span class="popover-header-title">{{ $t('HT.addRulePop.add') }}</span>
        <ux-button text icon="ux_icon_closed" @click="isShowAddSpecification = false"></ux-button>
      </div>
      <!-- 验证 -->
      <ux-form
        v-if="isShowAddSpecification"
        class="product-form my-vertical-form"
        ref="form"
        :rules="rules"
        :data="popFormData"
        width="200px"
        label-width="200px"
        hide-btn
      >
        <ux-form-item :label="$t('HT.addRulePop.type')" prop="type">
          <ux-select noSpace v-model="popFormData.type" :options="chargeModeOption"></ux-select>
        </ux-form-item>
        <ux-form-item :label="$t('HT.addRulePop.count')" prop="count">
          <ux-input
            noSpace
            v-model="popFormData.count"
            :placeholder="$t('HT.rules.positiveInteger.placeholder')"
            :regular="regPositiveInteger"
          ></ux-input>
        </ux-form-item>
        <ux-form-item :label="$t('HT.addRulePop.money')" prop="money">
          <ux-input
            noSpace
            v-model="popFormData.money"
            :placeholder="$t('HT.addRulePop.money')"
            :maxlength="7"
            :regular="regPositiveInteger"
          >
            <template slot="suffix">
              <span class="ux-input-number-suffix">
                {{ numberUnit }}
              </span>
            </template>
          </ux-input>
        </ux-form-item>
      </ux-form>
      <div class="product-popover-footer">
        <ux-button plain @click="isShowAddSpecification = false">{{ $t('HT.cancel') }}</ux-button>
        <ux-button type="primary" @click="confirm">{{ $t('HT.confirm') }}</ux-button>
      </div>
    </div>
    <ux-button
      slot="reference"
      type="primary"
      class="btn-product-add"
      :icon="icon"
      :text="text"
      :disabled="disabled"
      @click="resetPopFormData"
    >
      {{ content }}</ux-button
    >
  </el-popover>
</template>
<script>
import { NUMBER_UNITS } from '@l/constant.js';
import { rules } from '@l/rules.js';

export default {
  name: 'AddRulePop',
  props: {
    formData: {
      type: Object,
      default: () => {
        return {
          type: 0, // 计费方式
          count: '', // 配额量
          money: '' // 价格
        };
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    text: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'bottom-start'
    },
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      popFormData: {
        type: 0, // 计费方式
        count: '', // 配额量
        money: '' // 价格
      },
      chargeModeOption: this.$opt.ruleType,
      rules: this.$rul.addProductInfo(),
      isShowAddSpecification: false, // 显示添加规格pop
      regPositiveInteger: rules.positiveInteger().pattern // 包括0正整数
    };
  },
  created() {
    this.resetPopFormData();
  },
  computed: {
    numberUnit() {
      const len = String(this.popFormData.money || 0).length;
      return NUMBER_UNITS()[len];
    }
  },
  methods: {
    // 重置
    resetPopFormData() {
      this.popFormData = { ...this.formData };
    },
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const { type, count, money } = this.popFormData;
          this.$emit('confirm', {
            type, // 计费方式
            count: Number(count) * 10000, // 配额量
            money: Number(money) // 价格
          });
          this.$nextTick(() => {
            this.isShowAddSpecification = false;
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.product-popover {
  .popover-header {
    box-sizing: border-box;
    height: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 12px 8px;
    border-bottom: 1px solid $color-disable;

    .popover-header-title {
      font-size: 14px;
      font-weight: 600;
      color: $color-title;
    }

    .btn-product-add {
      font-size: 16px;
    }
  }

  .product-popover-footer {
    text-align: right;
    padding: 32px 12px 4px 0;

    .ux-button {
      margin-left: 8px;
    }
  }

  .product-form {
    margin: 0 auto;
    padding-top: 34px;
  }
}
</style>
